import React from "react";
import ReactDOM from "react-dom/client";
import Router from "./Router";
import { CssBaseline } from "@mui/material";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <CssBaseline />
    <Router />
  </React.StrictMode>
);
